import React, { useState, useEffect } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import NavInf from '../../components/NavInf/NavInf';
import EditStockModal from '../../components/EditStockModal/EditStockModal';
import Loader from '../../components/Loader/Loader';
import Alert from '../../components/Alert/Alert';
import { secureFetch } from '../../utils/secureFetch';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config/firebase';
import './EditInventory.css';

const EditInventory = () => {
    const [products, setProducts] = useState([]);
    const [productsToModal, setProductsToModal] = useState([]);
    const [loading, setLoading] = useState(true);
    const [alert, setAlert] = useState(null);

    useEffect(() => {
        const fetchProductsToModal = async () => {
            try {
                const user = JSON.parse(localStorage.getItem('usuario'));
                const providerId = user?.proveedorInfo?.id;
                if (!providerId) throw new Error('Proveedor no encontrado');

                const res = await fetch(`https://api.minymol.com/products/by-provider/${user.proveedorInfo.id}`);
                const data = await res.json();

                const ids = data.map(p => p.product_id).filter(Boolean);

                if (!ids.length) {
                    setProductsToModal([]);
                    return;
                }

                const previewsRes = await fetch('https://api.minymol.com/products/previews', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ ids })
                });

                const previews = await previewsRes.json();
                setProductsToModal(previews);
            } catch (err) {
                console.error('Error al cargar productos para el modal:', err);
            }
        };

        fetchProductsToModal();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await secureFetch('https://api.minymol.com/inventory/overview');
                if (!res.ok) throw new Error('Error al obtener inventario');
                const data = await res.json();
                setProducts(data.productos);
            } catch (err) {
                console.error('Error al cargar inventario:', err);
            } finally {
                setLoading(false);
            }
        };

        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                fetchData();
            }
        });

        return () => unsubscribe();
        
    }, []);

    const [search, setSearch] = useState("");
    const [modalProduct, setModalProduct] = useState(null);

    // Filtrar productos por nombre según el input de búsqueda
    const filteredProducts = products.filter(product =>
        product.name.toLowerCase().includes(search.toLowerCase())
    );

    const handleSaveStock = async (productId, data) => {
        try {
            const payload = {
                productId,
                colorId: data.colorId,
                sizeId: data.sizeId,
                type: data.type,        // 'ingreso' o 'egreso'
                quantity: data.quantity,
                note: data.note,
            };

            const res = await secureFetch('https://api.minymol.com/inventory/history', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (!res.ok) throw new Error('Error al guardar el movimiento');

            setAlert({
                type: 'success',
                message: 'Stock actualizado correctamente',
                redirectTo: null, // o pon '/ruta' si quieres redirigir
            });
        } catch (err) {
            console.error(err);
            setAlert({
                type: 'error',
                message: 'Error al actualizar stock',
            });
        }
    };


    if (loading) return <Loader />; // Mostrar loader mientras se cargan los datos

    return (
        <>
            <Header
                minimal={true}
                providerName={JSON.parse(localStorage.getItem('usuario'))?.proveedorInfo?.nombre_empresa}
                providerLogo={JSON.parse(localStorage.getItem('usuario'))?.proveedorInfo?.logo_url}
                menuProvider={true}
                currentPage='edit-inventory'
            />
            <div className="search-inventory-bar">
                <input
                    type="text"
                    placeholder="Buscar producto por nombre..."
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
            </div>
            <button
                className="edit-inventory-btn"
                onClick={() => setModalProduct({})} // Abre el modal para agregar un nuevo producto
            >
                Editar stock
            </button>
            <div className="inventory-container" id="inventory-container">
                {filteredProducts.length === 0 ? (
                    <div style={{ textAlign: 'center', color: '#888', margin: '2rem' }}>No tienes stock configurado. Presiona Editar stock para agregar inventarios.</div>
                ) : (
                    filteredProducts.map(product => (
                        <div key={product.id} className="inventory-card" id={`product-${product.id}`}>
                            <div className="inventory-header" id={`header-${product.id}`}>
                                <img src={product.image} alt={product.name} className="inventory-image" />
                                <div className='info-inventory-cont'>
                                    <h1 className="product-name">{product.name}</h1>
                                    <div className="inventory-history" id={`history-${product.id}`}>
                                        {product.history.map((entry, i) => (
                                            <div key={i} className="inventory-history-row" id={`history-${product.id}-${i}`}>
                                                <span className={`history-quantity ${entry.type}`}>
                                                    {entry.type === 'ingreso' ? '+' : '-'}{entry.quantity} unidades
                                                </span>
                                                <span className="history-date">{entry.date}</span>
                                                <span className="history-note">{entry.note}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
            {alert && (
                <Alert
                    type={alert.type}
                    message={alert.message}
                    onClose={() => setAlert(null)}
                    redirectTo={alert.redirectTo}
                />
            )}
            <NavInf />
            <Footer />
            {modalProduct && (
                <EditStockModal
                    products={productsToModal}
                    onClose={() => setModalProduct(null)}
                    onSave={handleSaveStock}
                />
            )}
        </>
    );
};

export default EditInventory;
